import React, { useEffect, useState } from "react";
import { logout } from "../../utils/api";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Drawer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  CircularProgress,
  Tooltip,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  Grid,
} from "@mui/material";
import PictureInPictureIcon from "@mui/icons-material/PictureInPicture";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import DownloadingIcon from "@mui/icons-material/Downloading";
import UserList from "../../components/orgDashboard/UserList";
import OrgUsersProfile from "../../components/orgDashboard/OrgUsersProfile";
import Logout from "@mui/icons-material/Logout";
import { BASE_URL } from "../../constants";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GroupIcon from "@mui/icons-material/Group";
import BusinessIcon from "@mui/icons-material/Business";
import ImageIcon from "@mui/icons-material/Image";
import { FILE_RULES, validateFile } from "../../utils/fileValidation";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowLeftRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftRounded";
import KeyboardDoubleArrowRightRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import { toast } from "react-toastify";
import CentreManagement from "./CentreManagement";
import PathologyReportLayoutGuide from "./PathologyReportLayoutGuide";
import RadiologyReportLayoutGuide from "./RadiologyReportLayoutGuide";
import MicrobiologyReportLayoutGuide from "./MicrobiologyReportLayoutGuide";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { authState } from "../../recoil/authAtom";
import OrgNavbar from "../../components/Org/OrgNavbar";

const OrgDashboard = () => {
  const navigate = useNavigate();
  const setAuth = useSetRecoilState(authState);
  const [openForm, setOpenForm] = useState(false);
  const [userData, setUserData] = useState({
    userName: "",
    userPassword: "",
    userConfirmPassword: "",
    userContact: "",
    role: "",
    isTechnician: false,
    techSignature: null,
    technicianHeader: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetchUsers, setFetchUsers] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openPdfForm, setOpenPdfForm] = useState(false);
  const [openPdfFormAppoint, setOpenPdfFormAppoint] = useState(false);
  const [openLayout, setOpenLayout] = useState(false);
  const [openRadioLayout, setOpenRadioLayout] = useState(false);
  const [openMicroLayout, setOpenMicroLayout] = useState(false);
  const [pdfFile, setPDFFile] = useState(null);
  const [pdfFileAppoint, setPDFFileAppoint] = useState(null);
  const [openCenter, setOpenCenter] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const sidebarWidth = sidebarCollapsed ? 76 : 260;

  const handleFormOpen = () => {
    setOpenForm(true);
  };

  const handlePDFFormOpen = () => {
    setOpenPdfForm(true);
  };

  const handlePDFFormOpenAppoint = () => {
    setOpenPdfFormAppoint(true);
  };

  const handlePDFFormClose = () => {
    setOpenPdfForm(false);
  };
  const handlePDFFormCloseAppoint = () => {
    setOpenPdfFormAppoint(false);
  };

  const handleFormClose = () => {
    setOpenForm(false);
    setUserData({
      userName: "",
      userPassword: "",
      userConfirmPassword: "",
      userContact: "",
      role: "",
      isTechnician: false,
      techSignature: null,
      technicianHeader: "",
    });
    setFormErrors({});
  };

  const handleInputChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSignFileChange = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.signature);
    if (!result.valid) {
      alert(result.error);
      e.target.value = "";
      return;
    }
    setUserData({
      ...userData,
      techSignature: file,
    });
  };
  const handlePdfFileChange = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.pdf);
    if (!result.valid) {
      alert(result.error);
      e.target.value = "";
      return;
    }
    setPDFFile({
      pdfFile: file,
    });
  };
  const handlePdfFileChangeAppoint = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.pdf);
    if (!result.valid) {
      alert(result.error);
      e.target.value = "";
      return;
    }
    setPDFFileAppoint({
      pdfFile: file,
    });
  };
  const validateForm = () => {
    const errors = {};

    if (!userData.userContact) errors.userContact = "Phone is required";
    else if (!/^[6-9]\d{9}$/.test(userData.userContact))
      errors.userContact = "Phone is invalid";

    if (!userData.userName) errors.userName = "Name is required";

    if (userData.userPassword.length < 8)
      errors.userPassword = "Password must be at least 8 characters";
    if (userData.userPassword !== userData.userConfirmPassword)
      errors.userConfirmPassword = "Passwords do not match";

    if (!userData.role) errors.role = "Please select a role";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    console.log(userData);
    const formData = new FormData();
    for (const key in userData) {
      formData.append(key, userData[key]);
    }
    // return;
    if (validateForm()) {
      setLoading(true);
      try {
        const response = await fetch(`${BASE_URL}api/org/register-user`, {
          method: "POST",
          headers: {},
          body: formData,
        });

        const data = await response.json();

        if (data.success) {
          console.log("Registration successful", data);
          alert(data.message);
          handleFormClose();
          setFetchUsers(!fetchUsers);
        } else {
          console.log("Error:", data.message);
          alert("Error: " + data.message);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong! Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  const handlePdfSubmit = async (e) => {
    e.preventDefault();
    console.log(12321, pdfFile.pdfFile);
    const formData = new FormData();
    formData.append("pdfFile", pdfFile.pdfFile);
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/org/upload-pdf`, {
        method: "POST",
        headers: {},
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        console.log("Registration successful", data);
        alert(data.message);
        handleFormClose();
        setFetchUsers(!fetchUsers);
      } else {
        console.log("Error:", data.message);
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePdfSubmitAppoint = async (e) => {
    e.preventDefault();
    console.log(12321, pdfFileAppoint.pdfFile);
    const formData = new FormData();
    formData.append("pdfFile", pdfFileAppoint.pdfFile);
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/org/upload-pdf-appoint`, {
        method: "POST",
        headers: {},
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        console.log("Registration successful", data);
        alert(data.message);
        // handleFormClose();
        // setFetchUsers(!fetchUsers);
      } else {
        console.log("Error:", data.message);
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const [loadingImport, setLoadingImport] = useState(false);

  const handleCopyTests = async () => {
    try {
      setLoadingImport(true);

      const response = await fetch(`${BASE_URL}api/org/copy-tests`, {
        method: "POST",
        headers: {},
      });

      const data = await response.json();
      if (data.success == false) {
        toast.warning(data.message);
      } else if (data.success == true) {
        toast.success(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const [allCenters, setAllCenters] = useState([]);
  const fetchAllCenters = async () => {
    try {
      const response = await fetch(`${BASE_URL}api/org/get-all-centers`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const resp = await response.json();
      if (resp.success) {
        setAllCenters(resp.data);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
    }
  };

  useEffect(() => {
    fetchAllCenters();
  }, []);

  const handleLogout = async () => {
    await logout();
    setAuth(null);
    navigate("/org-login", { replace: true });
  };

  return (
    // <>
    //   <Dialog
    //     open={openCenter}
    //     onClose={() => setOpenCenter(false)}
    //     maxWidth="xl" // bigger than xs
    //     fullWidth
    //     sx={{
    //       "& .MuiDialog-paper": {
    //         minWidth: "90%", // adjust as needed
    //       },
    //     }}
    //   >
    //     <CentreManagement allCenters={allCenters} />
    //   </Dialog>

    //   <Box display="flex">
    //     <Drawer
    //       variant="permanent"
    //       sx={{
    //         width: 280,
    //         flexShrink: 0,
    //         [`& .MuiDrawer-paper`]: {
    //           width: 280,
    //           boxSizing: "border-box",
    //           background: "linear-gradient(145deg, #2a3e52, #1b2b3f)", // Subtle gradient for depth
    //           color: "#ffffff",
    //           boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
    //           borderRight: "1px solid rgba(255, 255, 255, 0.1)",
    //         },
    //       }}
    //     >
    //       <Toolbar
    //         sx={{
    //           backgroundColor: "transparent",
    //           color: "#e0e0e0",
    //           fontWeight: "bold",
    //           fontSize: "1.2rem",
    //           textAlign: "center",
    //           justifyContent: "center",
    //           borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    //           boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
    //         }}
    //       >
    //         <Typography variant="h6" sx={{ flexGrow: 1 }}>
    //           User List
    //         </Typography>
    //       </Toolbar>
    //       <Box
    //         sx={{
    //           width: 280,
    //           overflowY: "auto",
    //           height: "calc(100vh - 64px)",
    //           backgroundColor: "#263a49",
    //           boxShadow: "inset 0px 4px 8px rgba(0, 0, 0, 0.2)",
    //         }}
    //       >
    //         <UserList
    //           fetchUsers={fetchUsers}
    //           setSelectedUser={setSelectedUser}
    //           selectedUser={selectedUser}
    //         />
    //       </Box>
    //     </Drawer>

    //     {/* Main content area */}
    //     <Box flex={1}>
    //       <AppBar position="static">
    //         <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
    //           <Box>
    //             <Tooltip title={"Add User"} placement="top">
    //               <IconButton
    //                 onClick={handleFormOpen}
    //                 sx={{
    //                   color: "white",
    //                 }}
    //               >
    //                 <PersonAddIcon />
    //               </IconButton>
    //             </Tooltip>
    //             <Tooltip title={"Report Template"} placement="top">
    //               <IconButton
    //                 onClick={handlePDFFormOpen}
    //                 sx={{
    //                   color: "white",
    //                 }}
    //               >
    //                 <PictureAsPdfIcon />
    //               </IconButton>
    //             </Tooltip>
    //             <Tooltip title={"Appointment Template"} placement="top">
    //               <IconButton
    //                 onClick={handlePDFFormOpenAppoint}
    //                 sx={{
    //                   color: "orange",
    //                 }}
    //               >
    //                 <PictureAsPdfIcon />
    //               </IconButton>
    //             </Tooltip>
    //             <Tooltip title={"Import Tests"} placement="top">
    //               <IconButton
    //                 onClick={handleCopyTests}
    //                 disabled={loadingImport}
    //               >
    //                 {loadingImport ? (
    //                   <CircularProgress
    //                     size={"1.3rem"}
    //                     sx={{ color: "#fff" }}
    //                   />
    //                 ) : (
    //                   <BrowserUpdatedIcon sx={{ color: "#fff" }} />
    //                 )}
    //               </IconButton>
    //             </Tooltip>
    //             <Tooltip title={"Pathology Report Layout"} placement="top">
    //               <IconButton onClick={() => setOpenLayout(true)}>
    //                 <PictureInPictureIcon sx={{ color: "#fff" }} />
    //               </IconButton>
    //             </Tooltip>
    //             <Tooltip title={"Radiology Report Layout"} placement="top">
    //               <IconButton onClick={() => setOpenRadioLayout(true)}>
    //                 <PictureInPictureIcon sx={{ color: "#fff" }} />
    //               </IconButton>
    //             </Tooltip>
    //             <Tooltip title={"Microbiology Report Layout"} placement="top">
    //               <IconButton onClick={() => setOpenMicroLayout(true)}>
    //                 <PictureInPictureIcon sx={{ color: "#fff" }} />
    //               </IconButton>
    //             </Tooltip>
    //           </Box>
    //           <Box sx={{ display: "flex", alignItems: "center" }}>
    //             <Typography onClick={() => setOpenCenter(true)}>
    //               Center Management
    //             </Typography>
    //             <Tooltip title="Logout" arrow>
    //               <IconButton onClick={handleLogout} color="inherit">
    //                 <Logout />
    //               </IconButton>
    //             </Tooltip>
    //           </Box>
    //         </Toolbar>
    //       </AppBar>
    //       <div>
    //         <OrgUsersProfile
    //           selectedUser={selectedUser}
    //           setFetchUsers={setFetchUsers}
    //           fetchUsers={fetchUsers}
    //         />
    //       </div>
    //       {/* Dialog form to add a new user */}
    //       <Dialog open={openForm} onClose={handleFormClose}>
    //         <DialogTitle>Add New User</DialogTitle>
    //         <DialogContent>
    //           <Grid container spacing={2}>
    //             <Grid item xs={12} md={6}>
    //               <TextField
    //                 autoFocus
    //                 name="userName"
    //                 label="User Name"
    //                 type="text"
    //                 size="small"
    //                 fullWidth
    //                 variant="filled"
    //                 value={userData.userName}
    //                 onChange={handleInputChange}
    //                 error={!!formErrors.userName}
    //                 helperText={formErrors.userName}
    //               />
    //             </Grid>
    //             <Grid item xs={12} md={6}>
    //               <TextField
    //                 name="userContact"
    //                 label="User Phone"
    //                 type="text"
    //                 fullWidth
    //                 size="small"
    //                 variant="filled"
    //                 value={userData.userContact}
    //                 onChange={handleInputChange}
    //                 error={!!formErrors.userContact}
    //                 helperText={formErrors.userContact}
    //               />
    //             </Grid>
    //             <Grid item xs={12} md={6}>
    //               <FormControl fullWidth variant="filled">
    //                 <InputLabel id="demo-simple-select-filled-label">
    //                   Role
    //                 </InputLabel>
    //                 <Select
    //                   fullWidth
    //                   labelId="demo-simple-select-filled-label"
    //                   id="demo-simple-select-filled"
    //                   value={userData.role}
    //                   name="role"
    //                   size="small"
    //                   onChange={handleInputChange}
    //                   error={!!formErrors.role}
    //                   helperText={formErrors.role}
    //                 >
    //                   <MenuItem value="Admin">Admin</MenuItem>
    //                   <MenuItem value="Front Office">Front Office</MenuItem>
    //                   <MenuItem value="Lab">Lab</MenuItem>
    //                   <MenuItem value="Finance">Finance</MenuItem>
    //                 </Select>
    //               </FormControl>
    //             </Grid>
    //             <Grid item xs={12} md={6}>
    //               <FormControl fullWidth variant="filled">
    //                 <InputLabel id="demo-simple-select-filled-label">
    //                   Is Technician?
    //                 </InputLabel>
    //                 <Select
    //                   fullWidth
    //                   labelId="demo-simple-select-filled-label"
    //                   id="demo-simple-select-filled"
    //                   value={userData.isTechnician}
    //                   name="isTechnician"
    //                   size="small"
    //                   onChange={handleInputChange}
    //                   // error={!!formErrors.isTechnician}
    //                   // helperText={formErrors.isTechnician}
    //                 >
    //                   <MenuItem value={true}>Yes</MenuItem>
    //                   <MenuItem value={false}>No</MenuItem>
    //                 </Select>
    //               </FormControl>
    //             </Grid>
    //             <Grid item xs={12} md={6}>
    //               <TextField
    //                 name="technicianHeader"
    //                 label="Technician Header"
    //                 type="text"
    //                 fullWidth
    //                 size="small"
    //                 variant="filled"
    //                 multiline
    //                 maxRows={4}
    //                 value={userData.technicianHeader}
    //                 onChange={handleInputChange}
    //                 // error={!!formErrors.userContact}
    //                 // helperText={formErrors.userContact}
    //               />
    //             </Grid>
    //             <Grid item xs={12}>
    //               <FormControl variant="filled" fullWidth>
    //                 <Typography
    //                   sx={{
    //                     position: "absolute",
    //                     fontSize: "12px",
    //                     padding: "5px",
    //                   }}
    //                 >
    //                   Signature
    //                 </Typography>
    //                 <TextField
    //                   type="file"
    //                   fullWidth
    //                   variant="filled"
    //                   name="techSignature"
    //                   onChange={handleSignFileChange}
    //                   inputProps={{ accept: "image/*" }}
    //                 />
    //               </FormControl>
    //             </Grid>
    //             <Grid item xs={12} md={6}>
    //               <TextField
    //                 name="userPassword"
    //                 label="Create Password"
    //                 type="password"
    //                 fullWidth
    //                 size="small"
    //                 variant="filled"
    //                 value={userData.userPassword}
    //                 onChange={handleInputChange}
    //                 error={!!formErrors.userPassword}
    //                 helperText={formErrors.userPassword}
    //               />
    //             </Grid>
    //             <Grid item xs={12} md={6}>
    //               <TextField
    //                 name="userConfirmPassword"
    //                 label="Confirm Password"
    //                 type="password"
    //                 fullWidth
    //                 size="small"
    //                 variant="filled"
    //                 value={userData.userConfirmPassword}
    //                 onChange={handleInputChange}
    //                 error={!!formErrors.userConfirmPassword}
    //                 helperText={formErrors.userConfirmPassword}
    //               />
    //             </Grid>
    //           </Grid>
    //         </DialogContent>
    //         {!loading ? (
    //           <DialogActions>
    //             <Button onClick={handleFormClose} color="secondary">
    //               Cancel
    //             </Button>
    //             <Button onClick={handleFormSubmit} color="primary">
    //               Submit
    //             </Button>
    //           </DialogActions>
    //         ) : (
    //           <DialogActions sx={{ justifyContent: "center", padding: 2 }}>
    //             <CircularProgress size={24} />
    //           </DialogActions>
    //         )}
    //       </Dialog>
    //       <Dialog open={openPdfForm} onClose={handlePDFFormClose}>
    //         <DialogTitle>
    //           {/* <Button onClick={handleFormClose} color="success">
    //           View PDF
    //         </Button> */}
    //         </DialogTitle>
    //         <DialogContent>
    //           <Grid container spacing={2}>
    //             <Grid item xs={12}>
    //               <FormControl variant="filled" fullWidth>
    //                 <Typography
    //                   sx={{
    //                     position: "absolute",
    //                     fontSize: "12px",
    //                     padding: "5px",
    //                   }}
    //                 >
    //                   Upload/Change PDF
    //                 </Typography>
    //                 <TextField
    //                   type="file"
    //                   fullWidth
    //                   variant="filled"
    //                   name="pdfFile"
    //                   onChange={handlePdfFileChange}
    //                   inputProps={{ accept: "application/pdf" }} // Accept only PDFs
    //                 />
    //               </FormControl>
    //             </Grid>
    //           </Grid>
    //           {console.log(pdfFile)}
    //         </DialogContent>
    //         {!loading ? (
    //           <DialogActions>
    //             <Button onClick={handlePDFFormClose} color="secondary">
    //               Cancel
    //             </Button>
    //             <Button onClick={handlePdfSubmit} color="primary">
    //               Submit
    //             </Button>
    //           </DialogActions>
    //         ) : (
    //           <DialogActions sx={{ justifyContent: "center", padding: 2 }}>
    //             <CircularProgress size={24} />
    //           </DialogActions>
    //         )}
    //       </Dialog>
    //       <Dialog open={openPdfFormAppoint} onClose={handlePDFFormCloseAppoint}>
    //         <DialogTitle>
    //           {/* <Button onClick={handleFormClose} color="success">
    //           View PDF
    //         </Button> */}
    //         </DialogTitle>
    //         <DialogContent>
    //           <Grid container spacing={2}>
    //             <Grid item xs={12}>
    //               <FormControl variant="filled" fullWidth>
    //                 <Typography
    //                   sx={{
    //                     position: "absolute",
    //                     fontSize: "12px",
    //                     padding: "5px",
    //                   }}
    //                 >
    //                   Upload/Change PDF
    //                 </Typography>
    //                 <TextField
    //                   type="file"
    //                   fullWidth
    //                   variant="filled"
    //                   name="pdfFile"
    //                   onChange={handlePdfFileChangeAppoint}
    //                   inputProps={{ accept: "application/pdf" }} // Accept only PDFs
    //                 />
    //               </FormControl>
    //             </Grid>
    //           </Grid>
    //           {console.log(pdfFile)}
    //         </DialogContent>
    //         {!loading ? (
    //           <DialogActions>
    //             <Button onClick={handlePDFFormCloseAppoint} color="secondary">
    //               Cancel
    //             </Button>
    //             <Button onClick={handlePdfSubmitAppoint} color="primary">
    //               Submit
    //             </Button>
    //           </DialogActions>
    //         ) : (
    //           <DialogActions sx={{ justifyContent: "center", padding: 2 }}>
    //             <CircularProgress size={24} />
    //           </DialogActions>
    //         )}
    //       </Dialog>

    //       <Dialog
    //         open={openLayout}
    //         onClose={() => setOpenLayout(false)}
    //         fullScreen
    //       >
    //         <DialogTitle sx={{ fontWeight: 600 }}>
    //           Pathology Report Layout Editor
    //         </DialogTitle>

    //         <DialogContent dividers sx={{ p: 0 }}>
    //           <PathologyReportLayoutGuide />
    //         </DialogContent>

    //         <DialogActions>
    //           <Button
    //             onClick={() => setOpenLayout(false)}
    //             color="error"
    //             variant="contained"
    //           >
    //             Close
    //           </Button>
    //         </DialogActions>
    //       </Dialog>

    //       <Dialog
    //         open={openRadioLayout}
    //         onClose={() => setOpenRadioLayout(false)}
    //         fullScreen
    //       >
    //         <DialogTitle sx={{ fontWeight: 600 }}>
    //           Radiology Report Layout Editor
    //         </DialogTitle>

    //         <DialogContent dividers sx={{ p: 0 }}>
    //           <RadiologyReportLayoutGuide />
    //         </DialogContent>

    //         <DialogActions>
    //           <Button
    //             onClick={() => setOpenRadioLayout(false)}
    //             color="error"
    //             variant="contained"
    //           >
    //             Close
    //           </Button>
    //         </DialogActions>
    //       </Dialog>

    //       <Dialog
    //         open={openMicroLayout}
    //         onClose={() => setOpenMicroLayout(false)}
    //         fullScreen
    //       >
    //         <DialogTitle sx={{ fontWeight: 600 }}>
    //           Micorbiology Report Layout Editor
    //         </DialogTitle>

    //         <DialogContent dividers sx={{ p: 0 }}>
    //           <MicrobiologyReportLayoutGuide />
    //         </DialogContent>

    //         <DialogActions>
    //           <Button
    //             onClick={() => setOpenMicroLayout(false)}
    //             color="error"
    //             variant="contained"
    //           >
    //             Close
    //           </Button>
    //         </DialogActions>
    //       </Dialog>
    //     </Box>
    //   </Box>
    // </>

    <>
      {/* ── Centre Management Dialog ── */}
      <Dialog
        open={openCenter}
        onClose={() => setOpenCenter(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: "1px solid #e5e9ef",
            boxShadow: "0 20px 60px rgba(10,31,68,0.18)",
            minWidth: "90%",
          },
        }}
      >
        <CentreManagement allCenters={allCenters} />
      </Dialog>

      <Box display="flex" sx={{ minHeight: "100vh", background: "#f4f6fb" }}>
        {/* ══ LEFT SIDEBAR ══ */}
        <Drawer
          variant="permanent"
          sx={{
            width: sidebarWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: sidebarWidth,
              boxSizing: "border-box",
              background:
                "linear-gradient(180deg, #0a1f44 0%, #0d2654 55%, #0a1f44 100%)",
              borderRight: "1px solid rgba(42,84,166,0.25)",
              boxShadow: "4px 0 24px rgba(10,31,68,0.18)",
              overflow: "hidden",
              transition: "width 240ms cubic-bezier(.2,.8,.2,1)",
            },
          }}
        >
          {/* Sidebar header */}
          <Box
            sx={{
              px: sidebarCollapsed ? 1.25 : 2.5,
              py: 2,
              borderBottom: "1px solid rgba(255,255,255,0.07)",
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              justifyContent: sidebarCollapsed ? "center" : "space-between",
              background: "rgba(0,0,0,0.15)",
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "2px",
                background: "linear-gradient(90deg,#2a54a6,#b93acf)",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "9px",
                  background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <GroupIcon sx={{ color: "#fff", fontSize: "1rem" }} />
              </Box>
              {!sidebarCollapsed && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.88rem",
                      fontWeight: 700,
                      color: "#ffffff",
                      lineHeight: 1.2,
                    }}
                  >
                    User List
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.6rem",
                      color: "rgba(255,255,255,0.45)",
                      mt: "1px",
                    }}
                  >
                    Organisation members
                  </Typography>
                </Box>
              )}
            </Box>
            <Tooltip
              title={
                sidebarCollapsed ? "Expand user list" : "Collapse user list"
              }
              placement="right"
              arrow
            >
              <IconButton
                aria-label={
                  sidebarCollapsed ? "Expand user list" : "Collapse user list"
                }
                onClick={() => setSidebarCollapsed((collapsed) => !collapsed)}
                size="small"
                sx={{
                  width: 28,
                  height: 28,
                  color: "rgba(255,255,255,.78)",
                  border: "1px solid rgba(255,255,255,.14)",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "rgba(255,255,255,.12)",
                  },
                }}
              >
                {sidebarCollapsed ? (
                  <KeyboardDoubleArrowRightRoundedIcon fontSize="small" />
                ) : (
                  <KeyboardDoubleArrowLeftRoundedIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          </Box>

          {!sidebarCollapsed && (
            <Box
              sx={{
                overflowY: "auto",
                height: "calc(100vh - 72px)",
                "&::-webkit-scrollbar": { width: "3px" },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(185,58,207,0.3)",
                  borderRadius: "4px",
                },
              }}
            >
              <UserList
                fetchUsers={fetchUsers}
                setSelectedUser={setSelectedUser}
                selectedUser={selectedUser}
              />
            </Box>
          )}
        </Drawer>

        {/* ══ MAIN CONTENT ══ */}
        <Box
          flex={1}
          sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}
        >
          {/* ── Organization Top Navbar (Dashboard & Calculation) ── */}
          <OrgNavbar onOpenCenter={() => setOpenCenter(true)} />

          {/* ── Top AppBar ── */}
          <AppBar
            position="static"
            elevation={0}
            sx={{
              background: "rgba(255,255,255,0.92)",
              backdropFilter: "blur(12px)",
              borderBottom: "1px solid #e5e9ef",
              boxShadow: "0 1px 12px rgba(10,31,68,0.06)",
            }}
          >
            <Toolbar
              sx={{
                display: "flex",
                justifyContent: "space-between",
                minHeight: "56px !important",
                px: 2,
              }}
            >
              {/* Left action buttons */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                {[
                  {
                    title: "Add User",
                    icon: <PersonAddIcon />,
                    onClick: handleFormOpen,
                    color: "#2a54a6",
                    bg: "rgba(42,84,166,0.08)",
                    border: "rgba(42,84,166,0.2)",
                  },
                  {
                    title: "Report Template",
                    icon: <PictureAsPdfIcon />,
                    onClick: handlePDFFormOpen,
                    color: "#2a54a6",
                    bg: "rgba(42,84,166,0.08)",
                    border: "rgba(42,84,166,0.2)",
                  },
                  {
                    title: "Appointment Template",
                    icon: <PictureAsPdfIcon />,
                    onClick: handlePDFFormOpenAppoint,
                    color: "#b93acf",
                    bg: "rgba(185,58,207,0.08)",
                    border: "rgba(185,58,207,0.2)",
                  },
                  {
                    title: "Pathology Layout",
                    icon: <PictureInPictureIcon />,
                    onClick: () => setOpenLayout(true),
                    color: "#059669",
                    bg: "rgba(16,185,129,0.08)",
                    border: "rgba(16,185,129,0.2)",
                  },
                  {
                    title: "Radiology Layout",
                    icon: <PictureInPictureIcon />,
                    onClick: () => setOpenRadioLayout(true),
                    color: "#0284c7",
                    bg: "rgba(2,132,199,0.08)",
                    border: "rgba(2,132,199,0.2)",
                  },
                  {
                    title: "Microbiology Layout",
                    icon: <PictureInPictureIcon />,
                    onClick: () => setOpenMicroLayout(true),
                    color: "#7c3aed",
                    bg: "rgba(124,58,237,0.08)",
                    border: "rgba(124,58,237,0.2)",
                  },
                ].map((btn) => (
                  <Tooltip
                    key={btn.title}
                    title={btn.title}
                    placement="bottom"
                    arrow
                  >
                    <IconButton
                      onClick={btn.onClick}
                      size="small"
                      sx={{
                        width: 34,
                        height: 34,
                        borderRadius: "9px",
                        background: btn.bg,
                        border: `1px solid ${btn.border}`,
                        color: btn.color,
                        "&:hover": {
                          background: btn.bg.replace("0.08", "0.15"),
                          transform: "translateY(-1px)",
                        },
                        transition: "all 0.2s ease",
                      }}
                    >
                      {btn.icon}
                    </IconButton>
                  </Tooltip>
                ))}

                {/* Import Tests (separate for loading state) */}
                <Tooltip title="Import Tests" placement="bottom" arrow>
                  <span>
                    <IconButton
                      onClick={handleCopyTests}
                      disabled={loadingImport}
                      size="small"
                      sx={{
                        width: 34,
                        height: 34,
                        borderRadius: "9px",
                        background: "rgba(249,115,22,0.08)",
                        border: "1px solid rgba(249,115,22,0.2)",
                        color: "#f97316",
                        "&:hover": {
                          background: "rgba(249,115,22,0.15)",
                          transform: "translateY(-1px)",
                        },
                        "&:disabled": {
                          background: "#f1f5f9",
                          color: "#cbd5e1",
                          border: "1px solid #e5e9ef",
                        },
                        transition: "all 0.2s ease",
                      }}
                    >
                      {loadingImport ? (
                        <CircularProgress size={16} sx={{ color: "#f97316" }} />
                      ) : (
                        <BrowserUpdatedIcon sx={{ fontSize: "1.1rem" }} />
                      )}
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>

              {/* Right: Centre Management + Logout */}
              {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  onClick={() => setOpenCenter(true)}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.75,
                    cursor: "pointer",
                    background:
                      "linear-gradient(135deg,rgba(42,84,166,0.08),rgba(185,58,207,0.06))",
                    border: "1px solid rgba(185,58,207,0.2)",
                    borderRadius: "9px",
                    px: 1.5,
                    py: 0.6,
                    "&:hover": {
                      background:
                        "linear-gradient(135deg,rgba(42,84,166,0.14),rgba(185,58,207,0.1))",
                      borderColor: "rgba(185,58,207,0.4)",
                    },
                    transition: "all 0.2s ease",
                  }}
                >
                  <BusinessIcon sx={{ fontSize: "0.9rem", color: "#2a54a6" }} />
                  <Typography
                    sx={{
                      fontSize: "0.78rem",
                      fontWeight: 700,
                      background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    Centre Management
                  </Typography>
                </Box>

                <Tooltip title="Logout" arrow>
                  <IconButton
                    onClick={handleLogout}
                    size="small"
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "9px",
                      background: "rgba(239,68,68,0.07)",
                      border: "1px solid rgba(239,68,68,0.2)",
                      color: "#dc2626",
                      "&:hover": {
                        background: "rgba(239,68,68,0.14)",
                        borderColor: "rgba(239,68,68,0.4)",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    <Logout sx={{ fontSize: "1rem" }} />
                  </IconButton>
                </Tooltip>
              </Box> */}
            </Toolbar>
          </AppBar>

          {/* Profile area */}
          <Box sx={{ flex: 1, p: 2 }}>
            <OrgUsersProfile
              selectedUser={selectedUser}
              setFetchUsers={setFetchUsers}
              fetchUsers={fetchUsers}
            />
          </Box>
        </Box>
      </Box>

      {/* ══ ADD USER DIALOG ══ */}
      <Dialog
        open={openForm}
        onClose={handleFormClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: "1px solid #e5e9ef",
            boxShadow: "0 20px 60px rgba(10,31,68,0.15)",
          },
        }}
      >
        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderBottom: "1px solid #e5e9ef",
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "2px",
              background: "linear-gradient(90deg,#2a54a6,#b93acf)",
            },
          }}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: "8px",
              background: "linear-gradient(135deg,#2a54a6,#b93acf)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PersonAddIcon sx={{ color: "#fff", fontSize: "0.95rem" }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "0.92rem",
                fontWeight: 700,
                color: "#0a1f44",
                lineHeight: 1.2,
              }}
            >
              Add New User
            </Typography>
            <Typography
              sx={{ fontSize: "0.62rem", color: "#94a3b8", mt: "1px" }}
            >
              Fill in the details to create a new user
            </Typography>
          </Box>
          <IconButton
            onClick={handleFormClose}
            size="small"
            sx={{
              ml: "auto",
              borderRadius: "8px",
              border: "1px solid #e5e9ef",
              p: "4px",
              "&:hover": {
                background: "rgba(239,68,68,0.07)",
                borderColor: "rgba(239,68,68,0.25)",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: "0.9rem", color: "#94a3b8" }} />
          </IconButton>
        </Box>

        <DialogContent sx={{ p: 2.5, background: "#f8fafc" }}>
          <Grid container spacing={1.75}>
            {[
              {
                name: "userName",
                label: "User Name",
                type: "text",
                autoFocus: true,
              },
              { name: "userContact", label: "Phone Number", type: "text" },
            ].map((f) => (
              <Grid item xs={12} sm={6} key={f.name}>
                <Typography sx={adLabelStyle}>
                  {f.label} <Req />
                </Typography>
                <TextField
                  autoFocus={f.autoFocus}
                  fullWidth
                  size="small"
                  name={f.name}
                  type={f.type}
                  value={userData[f.name]}
                  onChange={handleInputChange}
                  error={!!formErrors[f.name]}
                  helperText={formErrors[f.name]}
                  sx={adFieldStyle}
                />
              </Grid>
            ))}

            <Grid item xs={12} sm={6}>
              <Typography sx={adLabelStyle}>
                Role <Req />
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={userData.role}
                  name="role"
                  onChange={handleInputChange}
                  error={!!formErrors.role}
                  sx={adSelectStyle}
                >
                  {["Admin", "Front Office", "Lab", "Finance"].map((r) => (
                    <MenuItem key={r} value={r} sx={{ fontSize: "0.875rem" }}>
                      {r}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography sx={adLabelStyle}>Is Technician?</Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={userData.isTechnician}
                  name="isTechnician"
                  onChange={handleInputChange}
                  sx={adSelectStyle}
                >
                  <MenuItem value={true} sx={{ fontSize: "0.875rem" }}>
                    Yes
                  </MenuItem>
                  <MenuItem value={false} sx={{ fontSize: "0.875rem" }}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography sx={adLabelStyle}>
                Technician Header <Opt />
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="technicianHeader"
                multiline
                maxRows={3}
                value={userData.technicianHeader}
                onChange={handleInputChange}
                sx={adFieldStyle}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography sx={adLabelStyle}>
                Signature <Opt />
              </Typography>
              <Box
                sx={{
                  border: "1.5px dashed rgba(185,58,207,0.25)",
                  borderRadius: "10px",
                  p: 1.25,
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "8px",
                    background: "rgba(185,58,207,0.08)",
                    border: "1px solid rgba(185,58,207,0.18)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <ImageIcon sx={{ fontSize: "0.9rem", color: "#b93acf" }} />
                </Box>
                <input
                  type="file"
                  accept="image/*"
                  name="techSignature"
                  onChange={handleSignFileChange}
                  style={{
                    fontSize: "0.72rem",
                    color: "#0a1f44",
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </Box>
            </Grid>

            {[
              { name: "userPassword", label: "Create Password" },
              { name: "userConfirmPassword", label: "Confirm Password" },
            ].map((f) => (
              <Grid item xs={12} sm={6} key={f.name}>
                <Typography sx={adLabelStyle}>
                  {f.label} <Req />
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  name={f.name}
                  type="password"
                  value={userData[f.name]}
                  onChange={handleInputChange}
                  error={!!formErrors[f.name]}
                  helperText={formErrors[f.name]}
                  sx={adFieldStyle}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>

        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderTop: "1px solid #e5e9ef",
            background: "#fff",
            display: "flex",
            gap: 1.25,
            justifyContent: "flex-end",
          }}
        >
          {loading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CircularProgress size={18} sx={{ color: "#b93acf" }} />
              <Typography sx={{ fontSize: "0.78rem", color: "#64748b" }}>
                Creating user…
              </Typography>
            </Box>
          ) : (
            <>
              <Button
                onClick={handleFormClose}
                sx={{
                  textTransform: "none",
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  borderRadius: "9px",
                  px: 2,
                  border: "1px solid #e5e9ef",
                  color: "#64748b",
                  "&:hover": { background: "#f8fafc" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleFormSubmit}
                sx={{
                  textTransform: "none",
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  borderRadius: "9px",
                  px: 2.5,
                  background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                  color: "#fff",
                  boxShadow: "0 4px 12px rgba(185,58,207,0.28)",
                  "&:hover": {
                    background: "linear-gradient(135deg,#1e3d8a,#a02db8)",
                  },
                }}
              >
                Create User
              </Button>
            </>
          )}
        </Box>
      </Dialog>

      {/* ══ PDF UPLOAD DIALOGS (Report + Appointment) ══ */}
      {[
        {
          open: openPdfForm,
          onClose: handlePDFFormClose,
          onChange: handlePdfFileChange,
          onSubmit: handlePdfSubmit,
          title: "Report Template",
          subtitle: "Upload a PDF to use as the report template",
        },
        {
          open: openPdfFormAppoint,
          onClose: handlePDFFormCloseAppoint,
          onChange: handlePdfFileChangeAppoint,
          onSubmit: handlePdfSubmitAppoint,
          title: "Appointment Template",
          subtitle: "Upload a PDF to use as the appointment template",
        },
      ].map((d) => (
        <Dialog
          key={d.title}
          open={d.open}
          onClose={d.onClose}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "16px",
              border: "1px solid #e5e9ef",
              boxShadow: "0 20px 60px rgba(10,31,68,0.15)",
            },
          }}
        >
          <Box
            sx={{
              px: 2.5,
              py: 2,
              borderBottom: "1px solid #e5e9ef",
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "2px",
                background: "linear-gradient(90deg,#2a54a6,#b93acf)",
              },
            }}
          >
            <Typography
              sx={{ fontSize: "0.92rem", fontWeight: 700, color: "#0a1f44" }}
            >
              {d.title}
            </Typography>
            <Typography
              sx={{ fontSize: "0.68rem", color: "#94a3b8", mt: "2px" }}
            >
              {d.subtitle}
            </Typography>
          </Box>
          <DialogContent sx={{ p: 2.5, background: "#f8fafc" }}>
            <Box
              sx={{
                border: "2px dashed rgba(239,68,68,0.25)",
                borderRadius: "12px",
                p: 2,
                background: "#fff",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "9px",
                  background: "rgba(239,68,68,0.08)",
                  border: "1px solid rgba(239,68,68,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <PictureAsPdfIcon
                  sx={{ fontSize: "1.1rem", color: "#dc2626" }}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{ fontSize: "0.72rem", color: "#64748b", mb: 0.5 }}
                >
                  PDF files only
                </Typography>
                <input
                  type="file"
                  accept="application/pdf"
                  name="pdfFile"
                  onChange={d.onChange}
                  style={{ fontSize: "0.75rem", color: "#0a1f44" }}
                />
              </Box>
            </Box>
          </DialogContent>
          <Box
            sx={{
              px: 2.5,
              py: 2,
              borderTop: "1px solid #e5e9ef",
              background: "#fff",
              display: "flex",
              gap: 1.25,
              justifyContent: "flex-end",
            }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "#b93acf" }} />
            ) : (
              <>
                <Button
                  onClick={d.onClose}
                  sx={{
                    textTransform: "none",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    borderRadius: "9px",
                    px: 2,
                    border: "1px solid #e5e9ef",
                    color: "#64748b",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={d.onSubmit}
                  sx={{
                    textTransform: "none",
                    fontSize: "0.8rem",
                    fontWeight: 700,
                    borderRadius: "9px",
                    px: 2.5,
                    background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                    color: "#fff",
                    boxShadow: "0 4px 12px rgba(185,58,207,0.28)",
                    "&:hover": {
                      background: "linear-gradient(135deg,#1e3d8a,#a02db8)",
                    },
                  }}
                >
                  Upload
                </Button>
              </>
            )}
          </Box>
        </Dialog>
      ))}

      {/* ══ LAYOUT EDITOR DIALOGS ══ */}
      {[
        {
          open: openLayout,
          onClose: () => setOpenLayout(false),
          title: "Pathology Report Layout Editor",
          Component: PathologyReportLayoutGuide,
        },
        {
          open: openRadioLayout,
          onClose: () => setOpenRadioLayout(false),
          title: "Radiology Report Layout Editor",
          Component: RadiologyReportLayoutGuide,
        },
        {
          open: openMicroLayout,
          onClose: () => setOpenMicroLayout(false),
          title: "Microbiology Report Layout Editor",
          Component: MicrobiologyReportLayoutGuide,
        },
      ].map((d) => (
        <Dialog
          key={d.title}
          open={d.open}
          onClose={d.onClose}
          fullScreen
          PaperProps={{ sx: { background: "#f4f6fb" } }}
        >
          <Box
            sx={{
              px: 3,
              py: 2,
              borderBottom: "1px solid #e5e9ef",
              background: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "2px",
                background: "linear-gradient(90deg,#2a54a6,#b93acf)",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: "8px",
                  background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <PictureInPictureIcon
                  sx={{ color: "#fff", fontSize: "0.95rem" }}
                />
              </Box>
              <Typography
                sx={{ fontSize: "0.95rem", fontWeight: 700, color: "#0a1f44" }}
              >
                {d.title}
              </Typography>
            </Box>
            <Button
              onClick={d.onClose}
              startIcon={<CloseIcon sx={{ fontSize: "0.85rem !important" }} />}
              sx={{
                textTransform: "none",
                fontSize: "0.78rem",
                fontWeight: 700,
                borderRadius: "9px",
                px: 2,
                border: "1.5px solid rgba(239,68,68,0.25)",
                color: "#dc2626",
                background: "rgba(239,68,68,0.06)",
                "&:hover": {
                  background: "rgba(239,68,68,0.12)",
                  borderColor: "rgba(239,68,68,0.45)",
                },
              }}
            >
              Close
            </Button>
          </Box>
          <DialogContent sx={{ p: 0 }}>
            <d.Component />
          </DialogContent>
        </Dialog>
      ))}
    </>
  );
};

export default OrgDashboard;

const adLabelStyle = {
  fontSize: "0.65rem",
  fontWeight: 600,
  color: "#0a1f44",
  textTransform: "uppercase",
  letterSpacing: ".3px",
  mb: 0.55,
};
const adFieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "#ffffff",
    fontSize: "0.875rem",
    "& fieldset": { borderColor: "#e5e9ef" },
    "&:hover fieldset": { borderColor: "#2a54a6" },
    "&.Mui-focused fieldset": { borderColor: "#b93acf", borderWidth: "1.5px" },
  },
};
const adSelectStyle = {
  borderRadius: "10px",
  background: "#ffffff",
  fontSize: "0.875rem",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e5e9ef" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#2a54a6" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b93acf",
    borderWidth: "1.5px",
  },
};
const Req = () => (
  <Box component="span" sx={{ color: "#b93acf", ml: "2px", fontWeight: 700 }}>
    *
  </Box>
);
const Opt = () => (
  <Box
    component="span"
    sx={{ color: "#94a3b8", fontWeight: 400, ml: "3px", fontSize: "0.6rem" }}
  >
    (optional)
  </Box>
);
